var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15914_24235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99957 3.88845C4.99957 4.5021 4.5021 4.99957 3.88845 4.99957C3.27481 4.99957 2.77734 4.5021 2.77734 3.88845C2.77734 3.27481 3.27481 2.77734 3.88845 2.77734C4.5021 2.77734 4.99957 3.27481 4.99957 3.88845Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5427 14.7213C12.9046 15.0756 12.1701 15.2773 11.3885 15.2773C9.52325 15.2773 7.9264 14.1284 7.26708 12.4996H6.38845C5.92822 12.4996 5.55512 12.1265 5.55512 11.6662C5.55512 11.206 5.92822 10.8329 6.38845 10.8329H6.94401C6.94401 10.0234 7.16044 9.2644 7.5386 8.61068H6.38845C5.92822 8.61068 5.55512 8.23758 5.55512 7.77734C5.55512 7.31711 5.92822 6.94401 6.38845 6.94401H9.23512C9.87303 6.59003 10.6072 6.38845 11.3885 6.38845C13.8431 6.38845 15.8329 8.3783 15.8329 10.8329C15.8329 11.9016 15.4557 12.8821 14.8273 13.6487L16.9777 15.7992C17.3031 16.1246 17.3031 16.6523 16.9777 16.9777C16.6523 17.3031 16.1246 17.3031 15.7992 16.9777L13.5427 14.7213ZM14.1662 10.8329C14.1662 12.367 12.9226 13.6107 11.3885 13.6107C9.85433 13.6107 8.61068 12.367 8.61068 10.8329C8.61068 9.29878 9.85433 8.05512 11.3885 8.05512C12.9226 8.05512 14.1662 9.29878 14.1662 10.8329Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88845 8.88846C4.5021 8.88846 4.99957 8.39099 4.99957 7.77734C4.99957 7.16369 4.5021 6.66623 3.88845 6.66623C3.27481 6.66623 2.77734 7.16369 2.77734 7.77734C2.77734 8.39099 3.27481 8.88846 3.88845 8.88846Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99957 11.6662C4.99957 12.2799 4.5021 12.7773 3.88845 12.7773C3.27481 12.7773 2.77734 12.2799 2.77734 11.6662C2.77734 11.0526 3.27481 10.5551 3.88845 10.5551C4.5021 10.5551 4.99957 11.0526 4.99957 11.6662Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38845 3.05512C5.92822 3.05512 5.55512 3.42822 5.55512 3.88845C5.55512 4.34869 5.92822 4.72179 6.38845 4.72179H13.6107C14.0709 4.72179 14.444 4.34869 14.444 3.88845C14.444 3.42822 14.0709 3.05512 13.6107 3.05512H6.38845Z",
    fill: "#71869D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15914_24235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchNumber);
export default __webpack_public_path__ + "static/media/iconSearchNumber.8354158d9543356ac6da6397088c9fa9.svg";
export { ForwardRef as ReactComponent };